import { lazy } from 'react';
import Home from '@/pages/Home';
const MaintainancePage = lazy(() => import('@/pages/Maintanance'));

const COMPACT_PAGES: Record<string, { path: string; component: React.ReactNode; title: string }> = {
  HOME: {
    path: '/',
    component: <Home />,
    title: '',
  },
  MAINTAINANCE_PAGE: {
    path: '/under-maintenance',
    component: <MaintainancePage />,
    title: '',
  },
};

export default COMPACT_PAGES;
